module.exports = __webpack_public_path__ + "img/易损件.56412f67.jpg";